import { setStateDropDown as setCreateAccountStateDropDown } from 'Scripts/Slices/loginPage';
import { setStateDropDown as setFormPageStateDropDown } from 'Scripts/Slices/formPage';
import store from 'Scripts/store';

interface ICustomHandler {
    data: Record<string, any>;
    target:
        | (EventTarget & HTMLInputElement)
        | (EventTarget & HTMLSelectElement);
}

interface IOnChangeCountryData {
    countryValue: string;
    id: string;
}

const onChangeCountry = (
    data: IOnChangeCountryData,
    target: ICustomHandler['target']
) => {
    const { value } = target;
    if (value === data.countryValue) {
        store.dispatch(setFormPageStateDropDown({ value: true, id: data.id }));
    } else {
        store.dispatch(setFormPageStateDropDown({ value: false, id: data.id }));
    }
};

const onChangeCountryCreateAccount = (
    data: IOnChangeCountryData,
    target: ICustomHandler['target']
) => {
    const { value } = target;
    if (value === data.countryValue) {
        store.dispatch(
            setCreateAccountStateDropDown({ value: true, id: data.id })
        );
    } else {
        store.dispatch(
            setCreateAccountStateDropDown({ value: false, id: data.id })
        );
    }
};

// const onChangeJoinLoyaltyClub = (
//    data: ICustomHandler['data'],
//    target: ICustomHandler['target']
// ) => {
//     const { checked } = target;
//     store.dispatch(executeSetJoinLoyaltyClub(checked));
// };

export const executeFunctionByName = (
    functionName: string,
    data: Record<string, any>,
    target: (EventTarget & HTMLInputElement) | (EventTarget & HTMLSelectElement)
) => {
    switch (functionName) {
        case 'onChangeCountry':
            onChangeCountry(data as IOnChangeCountryData, target);
            break;
        case 'onChangeCountryCreateAccount':
            onChangeCountryCreateAccount(data as IOnChangeCountryData, target);
            break;
        // case 'onChangeJoinLoyaltyClub':
        //     onChangeJoinLoyaltyClub(data, target);
        //     break;
        default:
            break;
    }
};
